<template>
  <CommonDialog
    :dialog.sync="dialog"
    :head-text="headText"
    :confirm-button="confirmButton"
    :on-cancel="close"
    :on-confirm="massOperation"
    :content-text="contentText"
  >
    <v-form ref="form" v-if="destinationMode">
      <v-autocomplete
        v-model="destination_id"
        :items="destinations"
        item-text="name"
        item-value="id"
        :label="$t(this.destinationLabel)"
        :rules="[rules.required]"
      ></v-autocomplete>
    </v-form>
  </CommonDialog>
</template>

<script>
import { rules } from "./../../mixins/rules";
import { permissions } from "./../../mixins/permissions";
import CommonDialog from "./CommonDialog";
export default {
  name: "DialogForMassOperators",
  components: { CommonDialog },
  mixins: [rules, permissions],
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: function() {
        return [];
      }
    },
    destinations: {
      type: Array,
      default: function() {
        return [];
      }
    },
    destinationLabel: {
      type: String
    },
    permission: {
      type: String
    },
    confirmButton: {
      type: Object,
      default: function() {
        return {};
      }
    },
    headText: {
      type: String
    },
    contentText: {
      type: String
    },
    dispatch: {
      type: String
    },
    isWillRemove: {
      type: Boolean,
      default: false
    },
    onSuccess: {
      type: Function,
      default: function() {
        return function() {};
      }
    },
    permissionsItemKey: {
      type: String,
      default: ""
    },
    record_type: {
      type: String
    }
  },
  data: () => ({
    destination_id: ""
  }),
  computed: {
    destinationMode() {
      return !!(this.destinations && this.destinationLabel);
    }
  },
  methods: {
    massOperation() {
      if (this.destinationMode && !this.$refs["form"].validate()) {
        return;
      }
      let selected = this.getAllLegalSelected(this.permission);
      if (!selected && !selected.length) {
        return;
      }
      this.close();
      this.setLoading(true);
      if (this.isWillRemove) {
        this.setSelected(
          this.selected.map(i => {
            i.isWillRemoveSoon = !!selected.find(u => u.id === i.id);
            return i;
          })
        );
      }
      let filteredSelected = this.selected.filter(i => i && i.id);
      this.$store.dispatch(this.dispatch, {
        ids: filteredSelected.map(i => i.id),
        record_type: this.record_type,
        destination_id: this.destination_id,
        onSuccess: () => {
          this.setSelected(
            this.selected.filter(i => !selected.find(u => u.id === i.id))
          );
          this.setLoading(false);
          this.onSuccess();
        },
        onError: () => {
          if (this.isWillRemove) {
            this.setSelected(
              [...this.selected].map(i => {
                i.isWillRemoveSoon = !selected.find(u => u.id === i.id);
                return i;
              })
            );
          }
          this.setLoading(false);
        }
      });
    },
    getAllLegalSelected(role) {
      let items = this.selected.filter(i => !i.isWillRemoveSoon);
      let len = items.length;
      if (role) {
        items = items.filter(i => {
          return this.hasPermissions(
            this.permissionsItemKey ? i[this.permissionsItemKey] : i,
            role
          );
        });
      }
      if (items.length !== len) {
        this.$store.dispatch("notificationStore/createNotification", {
          text: this.$i18n.t("message.actions-could-not-be-processed"),
          type: "warning",
          value: true
        });
      }
      return items;
    },
    close() {
      this.$emit("update:dialog", false);
    },
    setSelected(selected) {
      this.$emit("update:selected", selected || []);
    },
    setLoading(val) {
      this.$emit("update:loading", val);
    }
  }
};
</script>

<style scoped></style>
